
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Heart } from "lucide-react";

const DiscoverySection = () => {
  return (
    <Card className="bg-gray-900/80 border-gray-600">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <Heart className="w-5 h-5 text-pink-500" />
          Discovery Preferences
        </CardTitle>
        <CardDescription className="text-gray-300">
          Customize who you see in discovery
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="recently-active">Recently Active</Label>
            <p className="text-sm text-gray-500">Prioritize recently active users</p>
          </div>
          <Switch id="recently-active" defaultChecked />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="verified">Verified Only</Label>
            <p className="text-sm text-gray-500">Show only verified profiles</p>
          </div>
          <Switch id="verified" />
        </div>
      </CardContent>
    </Card>
  );
};

export default DiscoverySection;
